import { createContext } from "react";

export type CustomerRouteContextValue = {
  /** CDH id for GraphQL variables. */
  customerCdhId: string;
  /** Value of `:customerId` in in-app routes; CDH or IAM id depending on config. */
  customerRouteId: string;
};

export const CustomerRouteContext = createContext<
  CustomerRouteContextValue | undefined
>(undefined);
